<template>
    <div>
        <Header></Header>
        <div class="row py-3 mb-4 justify-content-between pageTitleDiv">
            <div class="container pl-0">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                    {{$ml.get('REPORTS')}}
                </div>
            </div>  
        </div>
        <div class="container">
        <div class="row my-2 justify-content-between pageTitleDiv2">
                <div class="h1 d-flex align-items-center font-36 pageTitle">
                    {{$ml.get('REPORTS')}}
                </div>
            </div>
            <div class="row mt-3">
                <div v-if="windowWidth<maxMobilSize" class="d-block w-100 mb-3" @click="toggleClick('settingsTabMenuMobile')">
                    <div class="settingsMenuDropTitle ">
                        <span>{{$ml.get('REPORTS_MENU')}}</span>
                        <i class="fas fa-chevron-down ml-3"></i>
                    </div>
                </div> 
                <div class="col-3 pl-0" style="display:grid;">
                    <div class="settigsLeftMenu">
                        <ul class="nav settingsMenu" id="settingsTabMenuMobile" role="tablist"> 
                            <li class="w-100 text-center" @click="activeTab='deal'">
                                <div :class="{active:activeTab=='deal'}" >
                                    <button type="button" class="btn bg-white f-14 h-100 w-100 text-left">
                                        {{$ml.get('OPPORTUNITIES')}}
                                    </button>   
                                </div>
                            </li>
                            <li class="w-100 text-center" @click="activeTab='activity'">
                                <div :class="{active:activeTab=='activity'}"  >
                                    <button type="button" class="btn bg-white f-14 h-100 w-100 text-left">
                                        {{$ml.get('ACTIVITIES')}}
                                    </button>  
                                </div>
                            </li>
                            <li class="w-100 text-center dNoneMobil" @click="activeTab='jqueryBuilder'" v-if="$can('can_use_advanced_search')">
                                <div :class="{active:activeTab=='jqueryBuilder'}" >
                                    <button type="button" class="btn bg-white f-14 h-100 w-100 text-left">
                                        {{$ml.get('ADVANCED_SEARCH')}}
                                    </button>  
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-9 filter mb-2 p-0 reportsArea">
                    <div class="tab-content" style="min-height:200px">
                        <div :class="{active:activeTab=='deal'}" v-if="activeTab=='deal'">
                            <report-deal :user="user" :activeTab="activeTab" :permissions="permissions" :users="users"/>
                        </div>
                        <div :class="{active:activeTab=='activity'}" v-if="activeTab=='activity'" >
                            <report-activity :user="user" :activeTab="activeTab" :permissions="permissions" :users="users" />
                        </div>
                        <div :class="{active:activeTab=='jqueryBuilder'}"  v-if="$can('can_use_advanced_search')&&activeTab=='jqueryBuilder'">
                            <mqBuilder></mqBuilder>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from './header'
import reportDeal from './reportDeal.vue'
import reportActivity from './reportActivity.vue'
import mqBuilder from "./mongoQueryBuilder/main-area"
import axios from 'axios'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
export default {
  name: 'Settings',
  components: {
        Header,
        "report-deal":reportDeal,
        "report-activity":reportActivity,
        mqBuilder
    },
    computed: {
        ...mapState(['baseUrl','windowWidth','maxMobilSize','maxTabletSize']),
    },
    data () {
        return{
            user:{},
            users:[],
            permissions:[],
            activeTab:"deal"
        }
    },
    methods:{
        isActive(){
             
            axios({
                method:'POST',
                url:'/getUsers',
                baseURL: this.baseUrl,
                data: {
                },
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        this.user=res.data.content.user
                        this.users=res.data.content.users
                        this.permissions=res.data.content.permissions
                         
                    }
                }
            }).catch(() => {
                this.user = {}
                this.users = []
                this.permissions = []
            })
        },
        upToggle(id){
            if(this.windowWidth<this.maxMobilSize){
                $("#"+id).slideUp();
            }
        },
        toggleClick(id){
            if(this.windowWidth<this.maxMobilSize){
                $("#"+id).slideToggle();
                
            }
        },
        ...mapActions([
            'updateLoading'
        ]),
    },
    mounted(){
        this.isActive()
        if(this.windowWidth<this.maxMobilSize){
            this.upToggle('settingsTabMenuMobile')
        }
        
    },
    created(){
        
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tab-content>.tab-pane {
    display: none;
    height: 0;
    /*overflow: hidden;*/
}
.tab-content>.tab-pane.active {
    display: block!important;
    height: auto;
}
.settingsMenu{
    border-radius: 4px;
    overflow: hidden;
    border: 0.5px solid #AFC2D9;
}
.settingsMenu .active button{
    background: #3c89d8 !important;
    color: #FFF !important;
}
.settingsMenu button{
    color: #93959A;
    line-height: 27px;
    border-radius: 0;
}

.settingsMenu button{
    background: #F7FAFD;
}
.reportsArea{
    background-color: #FAFAFA;
    border: 0.5px solid #AFC2D9;
    border-radius: 4px;
    overflow: hidden;
}
.settingsMenuDropTitle{
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    background: #1991EB;
    color: #FFF;
    padding: 0.8rem 1rem;
    border-radius: 4px;
}
.pageTitleDiv{
    background-color: #fff;
    /* position: sticky; */
    top: 60px;
    z-index: 99;
}    
.pageTitleDiv2{
    display: none;
}
@media (max-width: 992px){
        .pageTitleDiv{
        display: initial;
    }
        .pageTitleDiv2{
       display: block;
    }
}
@media (max-width:768px){
    #settingsTabMenuMobile{
        position: absolute;
        z-index: 98;
        box-shadow: 2px 2px 10px;
        max-width: 540px !important;
        min-width: 150px;
        display: block;
        width: 100%;
    }
}
</style>
